import { GreetingConditionTypeEnum } from '@/entities/greetings'
import { type CreateOrUpdateGreetingModel } from '@/shared/api'
import { formatDayjsToDateString } from '@/shared/lib/form-utils'

import type { GreetingFormModel } from '..'

export function getGreetingSubmitRequestByFormValues(
  values: GreetingFormModel,
): CreateOrUpdateGreetingModel {
  return {
    name: values.name,
    title: values.title,
    description: values.description,
    conditionType: values.conditionType,
    sendOnStartDate:
      values.conditionType === GreetingConditionTypeEnum.EveryDay
        ? null
        : values.sendOnStartDate &&
          formatDayjsToDateString(values.sendOnStartDate),
    sendOnEndDate:
      values.sendOnEndDate &&
      values.conditionType === GreetingConditionTypeEnum.OnPeriod
        ? formatDayjsToDateString(values.sendOnEndDate)
        : null,
  }
}
